import { SimpleGrid, SkeletonText, Skeleton, Card } from '@chakra-ui/react';

export default function Loader() {
  return (
    <SimpleGrid columns={{ base: 1 }} spacing="8px">
      <Skeleton my="4" mt="1" width="66%" height="10px" />
      {Array.from({ length: 4 }, (_, index) => (
        <Card
          key={index}
          p={3}
          py={5}
          mb={2}
          variant="unstyled"
          borderRadius="16px"
          backgroundColor="bg.subtle"
        >
          <SkeletonText noOfLines={3} spacing="6" skeletonHeight="2" />
        </Card>
      ))}
    </SimpleGrid>
  );
}
